// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-title[data-v-2d648d66]{margin-top:5rem}.no-margin[data-v-2d648d66]{margin:0rem !important}.color-picker-input[data-v-2d648d66]{width:5rem}", ""]);
// Exports
module.exports = exports;
